import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import ManageBlogGridItem from "./ManageBlogGridItem";
import ManageBlogGridLoader from "./ManageBlogsGridLoader";
import {setManageBlogModals, tryLoadBlogs} from "../../../redux/slices/manageBlogSlice";
import {BLOG_TAB_TAGS} from "../constants";
import ChipGroup, {ChipSecondary} from "../../../components/Chips";


export default function ManageBlogsGrid() {

  const selectedTab = useSelector((state) => state.manageBlogs.selectedTab);

  const currentPage = useSelector((state) => state.manageBlogs[selectedTab].meta.page);


  const {
    loading = false, init = false, data: blogs = [], error = ""

  } = useSelector((state) => state.manageBlogs[selectedTab].pageData[currentPage]) ?? {};

  const dispatch = useDispatch();


  useEffect(() => {
    if (!init && !loading && !error)
      dispatch(tryLoadBlogs());
  }, [init, loading, error]);


  return (
    <_BlogsGrid blogs={blogs} error={error} init={init}/>
  );
}

function _BlogsGrid({init, blogs, error}) {
  const dispatch = useDispatch();


  return (
    <>
      {
        init && !!blogs.length ?

          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-2">

            {
              blogs.map((b) => <ManageBlogGridItem blog={b} key={b.id}/>)
            }

          </div>
          :
          <ManageBlogGridLoader error={error} retry={() => dispatch(tryLoadBlogs())} empty={init && !blogs.length}/>
      }


    </>
  );
}



